<template>
  <span
    :class="[
      {
        'preliminary-text': propertyReturn?.status === 'preliminary',
        'placeholder-text': !!propertyReturn?.placeholder && !propertyReturn.defaultOptions?.length,
      },
    ]"
    v-bind="showValueAsHtml ? { innerHTML: displayed } : slots.default ? undefined : { textContent: displayed }"
  />
</template>

<script setup lang="ts">
import { PropertyReturn } from '@/models/Property'
import { computed, useSlots } from 'vue'

const props = defineProps<{
  propertyReturn?: PropertyReturn
  showValueAsHtml?: boolean
}>()

const slots = useSlots()

const displayed = computed(() => (props.propertyReturn?.displayValue || props.propertyReturn?.placeholder) as string)
</script>

<style lang="scss" scoped></style>
